require('./bootstrap');
import Alpine from 'alpinejs';
import aplindata from './aplindata.js'
Alpine.data('data', aplindata)

window.Alpine = Alpine;
Alpine.start();
import collapse from '@alpinejs/collapse'
Alpine.plugin(collapse)

var errorElem = [];

document.onreadystatechange = () =>{
	if(document.readyState==='complete'){
		setTimeout(function(){ document.getElementById("loader").className = "hidden"; }, 1000);
		$("input , textarea, select").blur(function() {
			if($(this).val() !="") {
				$('#' + $(this).attr('id')).parent('div').parent('div').removeClass("has-warning");
				$('#' + $(this).attr('id')).parent('div').find("p").removeClass("fa fa-warning");
				$('#' + $(this).attr('id')).parent('div').parent('div').addClass("has-success");
				$('#' + $(this).attr('id')).parent('div').find("span").html("");
				$('#' + $(this).attr('id')).parent('div').find("p").html("");
				if ($(this).prop('type') == 'email'){
					if(!window.isEmail($(this).val())){
						$('#' + $(this).attr('id')).parent('div').find('span').html("Invalid Email Id.")
						$('#' + $(this).attr('id')).parent('div').parent('div').removeClass("has-success");
						$('#' + $(this).attr('id')).parent('div').parent('div').addClass("has-error");
					}
				}
			}else{
				if($('#' + $(this).attr('id')).hasClass('required')){
					$('#' + $(this).attr('id')).parent('div').addClass("has-warning");
				}
			}
		});
		window.checkFormRequiredField = function (formName) {
			var allValid = true;
			$($('form#'+formName).find(":input")).each(function(index ,i) {
				if($(this).attr('name')!="_token"){
					if($('#' + $(this).attr('id')).hasClass('required') && $('#' + $(this).attr('id')).val()==""){
						errorElem.push($(this).attr('id'));
					}
					if($(this).prop('type') == 'email' && !window.isEmail($(this).val())){
						errorElem.push($(this).attr('id'));
					}
				}
			});
			var sel= [];
			$($('form#'+formName).find(":selected")).each(function(index ,i) {
				if($(this).attr('name')!="_token"){
					if($('#' + $(this).attr('id')).hasClass('required') && $('#' + $(this).attr('id')).val()==""){
						errorElem.push($(this).attr('id'));
					}
				}
			});
			if(errorElem.length > 0){
				window. errorBlock();
				allValid = false;
			}
			return allValid;
		}
		window.postData = async function (url = '', data = {}) {
			const response = await fetch(url, {
				method: 'POST', // *GET, POST, PUT, DELETE, etc.
				credentials: 'same-origin', // include, *same-origin, omit
				headers: {
					'Content-Type': 'application/json',
					"Accept": "application/json",
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
				},
				body:JSON.stringify(data) 
			});
			return response.json();
		}
	}
	window.errorBlock = function(){
		console.log(errorElem);
		$('.has-error').removeClass('has-error');
		$('.bg-red-200').removeClass('bg-red-200');
		
		if(errorElem.length > 0){
			for(var i = 0; i < errorElem.length; i++){
				$('#' + errorElem[i]).addClass('has-error bg-red-200');
				$('#' + errorElem[i]).parent('div').addClass('has-error');
				$('#' + errorElem[i]).parent().parent('.form-group').addClass('has-error');
				$('#' + errorElem[i]).parent('div').find("p").html("<i class='fa fa-warning'></i> This Filed is Required");
				if($('#' + errorElem[i]).attr('type')=="checkbox"){
					$('#' + errorElem[i]).parent().parent('div').find("p").html("<i class='fa fa-warning'></i> This Filed is Required");
				}
			}
			errorElem = [];
		}
	}
	window.isEmail = function (email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	}
	 
}
